import React from "react";
import abimg2 from "../../images/sign.png";
import "./style.css";

const About = (props) => {
  return (
    <div id="about" className="about-style-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-12 col-12">
            <div className="about-img">
              <img src={props.AbImg} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 col-12">
            <div
              className="about-content"
              dir="rtl"
              style={{ textAlign: "right" }}
            >
              <div className="section-title">
                <h2 className="features-luxury__heading">جمعية جذور</h2>
              </div>
              <p style={{ fontSize: "18px" }}>
                نهدف لتعزيز مستوى الحماية االجتماعية للفئات االكثر ضعفا و هشاشة
                في المجتمع والعمل على نشر ثقافتها ومفاهيمها وأليات العمل الخاصة
                بها بالتركيز على حماية األطفال وإدماج االشخاص ذوي اإلعاقة في
                المجتمع وحماية المرأة وتحقيق مبادئ العدالة بين الجنسين
              </p>

              <div className="signature">
                <img style={{ width: "150px" }} src={abimg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
